<template>
  <section class="section__question">
    <Icon id="texture" class="section__question-icon" />
    <h2 class="title --smaller">{{ title }}</h2>
    <p>{{ content }}</p>
    <Button :route="{ name: 'faq' }" :label="button" class="--question" />
  </section>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Button from '@/components/small/Button.vue'

export default {
  name: 'Question',
  components: { Button, Icon },
  data() {
    return {
      button: this.$beet.options.faq.button_label,
      content: this.$beet.options.faq.content,
      title: this.$beet.options.faq.title,
    }
  },
}
</script>
